import MainModal from '@/common/components/base/modal/Modal';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import Typography from '@/common/components/base/typography/Typography';
import { reasonAlertType } from '@/modules/FileDetail/queries/alerts/alertsQuery.type';
import { Box } from 'styled-system/jsx';
import { ReasonModalProps } from '@/modules/FileDetail/components/renderAlert/alerts/modals/reasonModal/ReasonModal.types.ts';

export default ({ open, closeModal, reasonAlertItem }: ReasonModalProps) => (
  <MainModal open={open} closeModal={closeModal}>
    <ReasonModal reasonAlertItem={reasonAlertItem} />
  </MainModal>
);

const ReasonModal = ({
  reasonAlertItem,
}: {
  reasonAlertItem: reasonAlertType;
}) => {
  return (
    <>
      <TitleDescription textStyle="h2" color="black-1">
        {reasonAlertItem.fa_type}
      </TitleDescription>
      <Box my="24px" shadow="cardShadow" borderRadius="8px" p="16px">
        <Typography textStyle="b2" color="black-1">
          {reasonAlertItem.description}
        </Typography>
      </Box>
    </>
  );
};
